import { API_BASE } from '../utils/config';
import { apiFetch } from '../utils/apiFetch';

export interface ReviewInput {
  product_id: number;
  rating: number;
  title?: string;
  comment?: string;
}

export interface Review {
  id: string;
  user_id: string;
  product_id: number;
  rating: number;
  title: string;
  comment: string;
  is_verified_purchase: boolean;
  created_at: string;
  customer_name: string;
}

export const getReviewsByProductId = async (productId: number): Promise<Review[]> => {
  try {
    const res = await apiFetch(`${API_BASE}/reviews/${productId}`);
    const data = await res.json();
    return data.data || [];
  } catch {
    return [];
  }
};

export const createReview = async (review: ReviewInput): Promise<string | null> => {
  try {
    const res = await apiFetch(`${API_BASE}/reviews`, {
      method: 'POST',
      body: JSON.stringify(review),
    });
    const data = await res.json();
    return data.review_id || null;
  } catch {
    return null;
  }
};

export const updateReview = async (reviewId: string, review: ReviewInput): Promise<boolean> => {
  try {
    const res = await apiFetch(`${API_BASE}/reviews/${reviewId}`, {
      method: 'PUT',
      body: JSON.stringify(review),
    });
    return res.ok;
  } catch {
    return false;
  }
};

export const deleteReview = async (reviewId: string): Promise<boolean> => {
  try {
    const res = await apiFetch(`${API_BASE}/reviews/${reviewId}`, {
      method: 'DELETE',
    });
    return res.ok;
  } catch {
    return false;
  }
};
